import React, { useState, useContext, useEffect } from "react";
import { Container, Row, Button } from "react-bootstrap";
import Nav from "react-bootstrap/Nav";
import Navbar from "react-bootstrap/Navbar";
import { Link } from "react-router-dom";
import NavDropDownItem from "./NavDropDownItem";
import AuthContext from "../store/auth-context";
import Login from "./Login";
import "./Navigation.css";
import MenuContext from "../store/menu-context";



const Navigation = (props) => {
  const [collapseNav, setcollapseNav] = useState("");
  const [timeOfdayGreeting, settimeOfdayGreeting] = useState("Hello")
  // const [navObject, setnavObject] = useState(props.menuItems);
  const [expanded, setExpanded] = useState(false);
  const [logInUse, setLogInUser] = useState();
  // const [adminUser, setAdminUser] = useState(false);

  const authCtx = useContext(AuthContext);
  const navObject = useContext(MenuContext);

  // console.log('Inside Navigation');
  // console.log(navObject);

  const hideNav = (event) => {
    // setcollapseNav("collapsed");
    setExpanded(false);
  };

  // const fetchHtml = ( async () => {
  //   const apiResponse = await fetch(`/staticData/NavigationConfig.json`);
  //   const jsonApiResponse = await apiResponse.json();
  //   localStorage.setItem("MENU_ITEMS", jsonApiResponse);
  //   setnavObject({ ...jsonApiResponse });
  // })

  // useEffect(() => {  

  // },[authCtx])

  // useEffect(() => {
  //   // setnavObject(JSON.parse(sessionStorage.getItem("MENU_ITEMS")));
  //   setnavObject(props.menuItems)
  //   // console.log("Inside Navigation, loading menuItems: ", props.menuItems);
  //   // console.log("navObject is set");
  // }, [props.menuItems])

  useEffect(() => {
    var date = new Date();
    var hours = date.getHours();


    if (hours < 12) {
      settimeOfdayGreeting("Good Morning");
    } else if (hours < 18) {
      settimeOfdayGreeting("Good Afternoon");
    } else {
      settimeOfdayGreeting("Good Evening");
    }
  },[props]);

  
  function loadSubMenu(menuItem, menuItemId){
      if(menuItem !== "adminMenu" && menuItem !== "redirect"){
        if(typeof navObject[menuItem] !== 'string'){
          return(
            <NavDropDownItem item={menuItem} key={menuItemId} menuItemId={menuItemId} collapseMe={hideNav} menuItems={navObject}/>
            )
          }else {
          return(<Nav.Link key={menuItemId} href={navObject[menuItem]}>{menuItem}</Nav.Link>)
        }
      }
  }

  function loadAdminMenu(menuItem){
    // console.log("Trying to render admin menu");
    // console.log("menuItem: ", menuItem);
    // console.log("authCtx.accessLevel: ", authCtx.accessLevel);
    // console.log("navObject: ", navObject);
    // console.log("JSON.stringify(navObject): ", JSON.stringify(navObject));
    // console.log("read menu from session: ", JSON.parse(sessionStorage.getItem("MENU_ITEMS")));
    if(navObject && authCtx.accessLevel >= 2){
      return(
        <NavDropDownItem item={menuItem} key={menuItem} menuItemId={menuItem} collapseMe={hideNav} menuItems={navObject}/>
      )
    }
  }

  return (
    <>
      <Row lg={12}>
        <Navbar collapseOnSelect expanded={expanded} className="navBar fixed-top" id="navbar" expand="lg">
          <Container fluid>
            <Navbar.Toggle
              aria-controls="responsive-navbar-nav"
              id="navbar-toggle"
              className={collapseNav}
              onClick={() => setExpanded(expanded ? false : "expanded")}
            />
            <Navbar.Collapse id="basic-navbar-nav">
              <Nav className="mx-auto" id="nav">
                <Nav.Link as={Link} key="Home" to="/content/home.html">Home</Nav.Link>
                <Nav.Link as={Link} key="TeacherSearch" to="/local/teachersearch">Teacher Search</Nav.Link>
                {navObject && 
                  Object.keys(navObject).map((menuItem, menuItemId) => (
                    // (menuItem === "adminMenu" || menuItem === "redirect") 
                    // ? undefined : 
                    // <NavDropDownItem item={menuItem} key={menuItemId} collapseMe={hideNav} />
                    loadSubMenu(menuItem, menuItemId)
                    ))
                }
                {
                  navObject && loadAdminMenu("adminMenu")
                    //  authCtx.accessLevel >= 2 && 
                    // <NavDropDownItem item="adminMenu" key="adminMenu" menuItemId="adminMenu" menuItems={navObject} collapseMe={hideNav} />
                }
                <Nav.Link as={Link} key="MSMTA" to="/external/msmta.html">MSMTA</Nav.Link>
              </Nav>
              <Navbar.Text className="mx-auto">
                {authCtx.isLoggedIn ? 
                <table>
                <tr>
                  <td style={{padding: 10}}>
                  <strong>{timeOfdayGreeting} {authCtx.memberName}</strong>
                  </td>
                  <td>
                <Button className="shadow" variant="success" onClick={authCtx.onLogout}>
                  Logout
                </Button>
                 </td>
                 </tr>
                 </table> :
                // `Hello: <a href="#login">${authCtx.memberName}</a>` : 
                <Login handleLogin={authCtx.onLogin} variant="success"/> }
              </Navbar.Text>
            </Navbar.Collapse>
          </Container>
        </Navbar>
      </Row>
      <Row lg={12}>
        <hr></hr>
      </Row>
    </>
  );
};

export default Navigation;
